import { DealsTable } from 'components/Tables/DealsTable/DealsTable'
import { CompanyTypeSlug, TableTypeSlug } from 'models/companies'
import { useState } from 'react'
import { FaPlus } from 'react-icons/fa'
import { queryClient } from '../../../services/queryClient'
import FbButton from '../../FbUI/FbButton'
import { CollapsibleSection } from '../../UI/CollapsibleSection/CollapsibleSection'
import CreateDealModal from '../CreateDealModal/CreateDealModal'

export default function DealsSection({
  forCompany,
  pagination,
  tableTypeSlug,
  companyTypeSlug,
  isUserCreated,
  forDoorProxyId,
}: {
  forCompany?: { id?: number }
  pagination?: boolean
  tableTypeSlug: TableTypeSlug
  companyTypeSlug: CompanyTypeSlug
  isUserCreated?: boolean
  forDoorProxyId?: number
}) {
  const TABLE_KEY = forDoorProxyId
    ? `door-proxy-deals-table-${forDoorProxyId}`
    : `company-deals-table-${forCompany?.id}`
  const [showNewDeal, setShowNewDealModal] = useState(false)
  const [dealsCount, setDealsCount] = useState(0)

  return (
    <CollapsibleSection
      forceClose={dealsCount < 1}
      summary={
        <div className={'flex justify-between items-center w-full'}>
          <div>
            Deals <span className={'font-thin'}>({dealsCount})</span>
          </div>
          <FbButton onClick={() => setShowNewDealModal(true)}>
            <FaPlus size={14} /> Add Deals
          </FbButton>
        </div>
      }
    >
      {showNewDeal && (
        <CreateDealModal
          totalSelectedRows={1}
          optimisticUiTarget="deals-section"
          show={showNewDeal}
          handleClose={() => setShowNewDealModal(false)}
          targetCompanyId={forCompany?.id}
          targetDoorProxyId={forDoorProxyId}
          forDoorSelection={!!forDoorProxyId}
          tableTypeSlug={tableTypeSlug}
          companyTypeSlug={companyTypeSlug}
          isUserCreated={isUserCreated}
          onDealCreated={() => {
            queryClient.invalidateQueries({ queryKey: [TABLE_KEY] })
          }}
        />
      )}

      <DealsTable
        tableKey={TABLE_KEY}
        forCompany={forCompany}
        forDoorProxyId={forDoorProxyId}
        setTotalRowsCount={setDealsCount}
        enablePagination={pagination}
        disableUrlPagination
        showCompanyColumn={false}
      />
    </CollapsibleSection>
  )
}
